import PropTypes from 'prop-types';

import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import { useTheme } from '@zenbusiness/zui/styles';

import { CategoryPill } from '../CategoryPill';
import { Estimate } from '../Estimate';
import { PartnerImage } from '../PartnerImage';
import { Status } from '../Status';
import * as Styled from './Footer.style';
import { PRODUCT_CARD_STATUS } from '../../constants';

function Footer({
  categories,
  estimate,
  partnerImageUrl,
  product,
  status,
  url
}) {
  const theme = useTheme();
  const hasExcessContent = estimate || url || categories;
  const isPurchasedOrRequested = status?.state === PRODUCT_CARD_STATUS.PURCHASED.state
    || status?.state === PRODUCT_CARD_STATUS.REQUESTED.state;

  const unpurchasedCategories = categories.filter(
    (category) => category.state !== PRODUCT_CARD_STATUS.PURCHASED.state
  );

  return (
    <Styled.Footer>
      <Stack gap={2} horizontal sx={{ alignItems: 'center' }}>
        <Status product={product} status={status} />
        <PartnerImage partnerImageUrl={partnerImageUrl} />
      </Stack>
      {hasExcessContent && (
        <Stack gap={2} horizontal sx={{ alignItems: 'center' }}>
          {!isPurchasedOrRequested && <Estimate estimate={estimate} />}

          <CategoryPill categories={unpurchasedCategories} />

          {url && (
            <SharedAsset
              alt=""
              color={theme.palette.text.secondary}
              src="/s2/icon/external-link-outline.svg"
            />
          )}
        </Stack>
      )}
    </Styled.Footer>
  );
}

Footer.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      state: PropTypes.string
    })
  ),
  estimate: PropTypes.string,
  partnerImageUrl: PropTypes.string,
  product: PropTypes.shape({
    pricing: PropTypes.shape({
      amount: PropTypes.number,
      formattedPricePerInterval: PropTypes.string
    })
  }),
  status: PropTypes.shape({
    state: PropTypes.string
  }),
  url: PropTypes.string
};

export default Footer;
